export function makeDataSample() {
  return {
    targetReceived: 6500000,
    link: 'trakteer.id/egis/gift',
    activeUnit: {
      "id": "qmv7dk48x5b690wx",
      "name": "Cendol",
      "price": "10000.00",
      "icon": "https://cdn.trakteer.id/images/mix/ice-cream.png"
    }
  }
}

export function makeMilestoneListSample() {
  return [
    {target: 500000, description: "Fire noodle challange"},
    {target: 2500000, description: "Dance stecu stecu"},
    {target: 5000000, description: "Play a rage game"},
    {target: 10000000, description: "Stream a board game night"},
    {target: 11000000, description: "Wear spiderman suit"},
    {target: 12000000, description: "Show off my snack stash"},
    {target: 13000000, description: "Play some console game"},
    {target: 14000000, description: "Play a childhood favorite game"},
    {target: 15000000, description: "Do a blindfold challenge"},
    {target: 16000000, description: "Sing a cringe pop song"},
    {target: 17000000, description: "Stream an outdoor walk"},
    {target: 18000000, description: "Room tour"},
    {target: 19000000, description: "Study tour"},
    {target: 20000000, description: "WORK OUT"},
    {target: 21000000, description: "Do a cooking stream"},
    {target: 22000000, description: "Cosplay as chat’s choice"},
    {target: 23000000, description: "Go on a mini IRL adventure"},
    {target: 24000000, description: "Collab with famous youtuber"},
  ]
}
export async function handlePreview(manager) {
  window.addEventListener('message', (e) => {
    if(e.data.list) {
      let listMilestone = e.data.list
      if(h.isTrue(manager.get('use_placeholder'))) {
        if(listMilestone.length != 0) {
          manager.updateMilestoneListAndRemainingPreview(listMilestone, manager.widget.data);
        }
      } else {
        manager.updateMilestoneListAndRemainingPreview(listMilestone, manager.widget.data);
      }
    }
  });

  if (h.isTrue(manager.get('use_placeholder'))) {
    manager.reload(false, makeDataSample())
    manager.updateMilestoneListAndRemainingPreview(makeMilestoneListSample(), makeDataSample());
  } else {
    await manager.loadData();
  }

  let data = {
    isReady: true,
  }
  window.parent.postMessage(data, h.isProduction() ? "https://trakteer.id" : window.location.origin);

}